import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { IAppointment } from '../../programari/programari.interface';
import { ICerere } from '../../cereri/cereri.interface';
import { formConfigurations, matrimonialRegimes, militaryRanks, militaryStatuses } from '../../cereri/cereri-detalii/informatii-aditionale/informatii-aditionale';
import { CereriService } from '../../cereri/cereri.service';
import { AppFilesService } from 'src/app/services/app-files.service';

@Component({
    selector: 'app-view-expansion-panel',
    templateUrl: './view-expansion-panel.component.html',
    styleUrls: ['./view-expansion-panel.component.scss']
})
export class ViewExpansionPanelComponent implements OnInit {
    @Input() appointment!: IAppointment;
    @Input() cerere!: ICerere;

    currentFormFields: Array<{
        label: string;
        value: string;
        type?: string;
    }> = [];

    militaryStatuses = militaryStatuses;
    militaryRanks = militaryRanks;
    matrimonialRegimes = matrimonialRegimes;

    constructor(
        private cereriService: CereriService,
        private appFileService: AppFilesService
    ) { }

    ngOnInit(): void {
        console.log('appointment', this.appointment);
        console.log('cerere', this.cerere);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getCurrentFormFields();
        if (changes['cerere']) {
            let currentSlug = this.cerere?.slug || 'default-slug';

            this.currentFormFields = formConfigurations[currentSlug] || [];
        }
    }

    getCurrentFormFields(): Array<{
        label: string;
        value: string;
        type?: string;
    }> {
        let currentSlug = this.cerere?.slug || 'default-slug';

        const allFields = formConfigurations[currentSlug] || [];

        // Mark checkbox fields
        return allFields.map((field) => {
            return {
                ...field,
                isCheckboxField: field.value.includes('.'),
            };
        });
    }

    getDocumentTypeKeys(): string[] {
        return this.cerere ? Object.keys(this.cerere.documente) : [];
    }

    getDocumentKeys(docTypeKey: string): string[] {
        return this.cerere
            ? Object.keys(this.cerere.documente[docTypeKey].documente)
            : [];
    }

    mapValueToName(
        controlValue: string | number | null,
        nameValueList: { name: string, value: string }[]
    ) {
        if (controlValue) {
            const status = nameValueList.find(status => status.value === controlValue);
            if (status) {
                return status.name;
            }
        }

        return 'N/A';
    }

    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.appFileService.downloadFile(fullPath);
    }
}
